import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import SingleTour from './tour/SingleTour';
import http from 'http';
import https from 'https';
import Helmet from "react-helmet";
import ReactDOM from 'react-dom';



var tourId;
import * as toursActions from '../actions/tours';

var urlParams = {};




class Tour extends Component {


  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleRefreshClick = this.handleRefreshClick.bind(this);


  }

  componentDidUpdate() {
    //console.log('componentDidUpdate');
    //console.log(this.props.params.param_id);
  }

  componentWillReceiveProps() {


    if (this.props.tour.gallery_id && this.props.gallery.id != this.props.tour.gallery_id) {
        this.props.toursActions.fetchGalleryIfNeeded(this.props.tour.gallery_id);
    }

    if (parseInt(this.props.params.param_id) !== parseInt(this.props.tour.id) && (!this.props.tour.id_old || (this.props.tour.id_old && parseInt(this.props.params.param_id) !== parseInt(this.props.tour.id_old)))) {
      tourId = this.props.tour.id;
      this.props.toursActions.selectTour(Object.assign(this.props.tour, {id: this.props.params.param_id}));
      this.props.toursActions.fetchPostsIfNeeded(1, this.props.params.param_id);
      this.props.toursActions.fetchReviews(this.props.params.param_id);
    }


  }

  
  

  componentWillUpdate() {
    if (this.wrapper && this.wrapper.clientWidth) {
      this.wrapperWidth = this.wrapper.clientWidth;
    }
  }

  eventUndo(e) {
    e.preventDefault();
    this.props.undo();
  }

  eventRedo(e) {
    e.preventDefault();
    this.props.redo();
  }



  componentDidMount() {

    if (!this.props.tour || (this.props.tour && !this.props.tour.programDays)) {

      this.props.toursActions.fetchPostsIfNeeded(1, this.props.params.param_id);

    }

    this.props.toursActions.setMapConfig({
      active: false,
      activeRoute: true,
      fixed: true,
      hiddenOnScroll: true
    });


    if (this.props.tour.gallery_id) {
      //console.log(this.props.tour.gallery_id);
      this.props.toursActions.fetchGallery(this.props.tour.gallery_id);
    }


    this.props.toursActions.fetchReviews(this.props.tour.id);

  }

  componentWillMount() {
    tourId = this.props.params.param_id;
    this.wrapper = ReactDOM.findDOMNode(this.refs.wrap);
  }


  componentWillUnmount() {

    this.props.toursActions.setMapConfig({
      activeRoute: false,
      fixed: false,
      hiddenOnScroll: false
    });
    this.props.toursActions.setScroll({scrollY: 0, opacity: 1});
  }


  handleChange(nextTour) {
    this.props.selectTour(nextTour);
  }

  onBtnClick() {

    this.props.fetchPostsIfNeeded(1, 1);
  }
  handleRefreshClick(e) {
    e.preventDefault();
    this.props.fetchPostsIfNeeded(1, this.props.params.param_id);
  }



  nextDay() {
    this.props.nextDay()
  }
  prevDay() {
    this.props.prevDay();
  }
  
  render () {
    const { tour, currency, currencyList, selectedTab, shareOpen, seo, translations, reviews, openedReviews, fetchReviews, reviewsPopupOpen, reviewsLang } = this.props;

 

    let re = /<[^>]+>/g;
    let description = (tour.content)?tour.content.replace(re, ''):"";
    description = description.substr(0, 205);
    let lastSpace = description.lastIndexOf(" ");
    if( lastSpace > 0 && description.length > 200) {
      description = description.substr(0, lastSpace);
    }

    let meta = [
      {"name": "description", "content": (seo.description)?seo.description:description}
    ];


    let width = this.wrapperWidth;
    let photoSize = 1400;
    let sizes = [2560, 1920, 1400, 1000];
    sizes.forEach(function(size){
      if (width && width <= size) {
        photoSize = size;
      }
    });


    meta.push({
      property: "og:image",
      content: ((tour.coverImages && tour.coverImages.previews)?tour.coverImages.previews.browsing1000:'')
    });
    /*
    meta.push({
      property: "og:description",
      content: description
    });
    meta.push({
      property: "og:title",
      content: tour.title
    });
  }); */

    let title = tour.title + ' - ' + translations.tour__title;
    if (tour.destinations) {
      tour.destinations.forEach(function(destination){
            title += ' - ' + destination.title;

      });
    }

    return (
      <div>

        <Helmet
            title={(seo.title)?seo.title:title}
            meta={meta}
        />
        {this.props.tour &&
          <div ref="wrap">
            <SingleTour actions={this.props.toursActions} width={photoSize} reviewsLang={reviewsLang} reviewsPageCount={this.props.reviewsPageCount} reviewsPopupOpen={reviewsPopupOpen} fetchReviews={fetchReviews} reviews={reviews} openedReviews={openedReviews} userActions={this.props.userActions} currency={currency} selectedTab={selectedTab} shareOpen={shareOpen} currencyList={currencyList} lang={this.props.lang} tour={this.props.tour} discountOpen={this.props.discountOpen} list={this.props.list} gallery={this.props.gallery} toggleDeparture={this.props.toggleDeparture} selectDeparture={this.props.selectDeparture} nextDay={this.props.nextDay} prevDay={this.props.prevDay} selectDay={this.props.selectDay} hoverDay={this.props.hoverDay} selectPhoto={this.props.selectPhoto} setViewDayPhoto={this.props.setViewDayPhoto}  />
          </div>
        }
      </div>
    );
  }
}

Tour.need = [
  {
    action: toursActions.fetchPosts
  },
  {
    action: toursActions.fetchReviews
  }
];

export default Tour;


// WEBPACK FOOTER //
// ./src/common/components/Tour.js